import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  SwapOutlined,
} from '@ant-design/icons'
import classNames from 'classnames'

import type { SortOrder } from '@/utils/table/columnSort'

import cn from './SortableColumnTitle.module.scss'

type SortableColumnTitleProps = {
  title: string
  order: SortOrder | null
  onToggle: () => void
  isOrganisationSelected?: boolean
}

const SORT_ICONS = {
  ASC: <ArrowUpOutlined aria-hidden />,
  DESC: <ArrowDownOutlined aria-hidden />,
}

const SORT_HINTS = {
  ASC: 'по возрастанию',
  DESC: 'по убыванию',
}

function SortableColumnTitle({
  title,
  order,
  onToggle,
  isOrganisationSelected = false,
}: SortableColumnTitleProps) {
  const hint = order ? `, сейчас ${SORT_HINTS[order]}` : ''

  return (
    <button
      type="button"
      className={classNames(
        cn.sortButton,
        order && cn.applied,
        isOrganisationSelected && cn.organisationSelected
      )}
      aria-label={`Сортировать: ${title}${hint}`}
      onClick={onToggle}
    >
      <span className={cn.title}>{title}</span>
      {order ? (
        SORT_ICONS[order]
      ) : (
        <SwapOutlined aria-hidden className={cn.idleIcon} />
      )}
    </button>
  )
}

export default SortableColumnTitle
